const useFormatCurrency = () => {
    const locale = navigator.language || "nl-NL";

    return (value) =>
        new Intl.NumberFormat(locale, {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 2,
        }).format(value);
};

export default useFormatCurrency;